import { render, staticRenderFns } from "./PlayStoreIcon.vue?vue&type=template&id=014acadc"
import script from "./PlayStoreIcon.vue?vue&type=script&lang=js"
export * from "./PlayStoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports